module.exports = __webpack_public_path__ + "img/ECONTROL-VR.01eb8bda.png";